import React from 'react';

import { Header } from './../Header/Header';

import './styles.css';

export const CoverDiv = () => (
    <div className="cover-div">
        <Header/>
    </div>
)